import React, { useState, useEffect } from 'react';
import { Box, Button as ButtonMUI, FormControl, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Modal } from 'vqp-common';
import { Loading } from '../../common';
import { FormLabelControl, IOSSwitch } from '../../../pages/Settings/style';
import { Motorcycle as MopedIcon, Store as StoreIcon } from '@material-ui/icons';
import { api } from '../../../redux/store';
import withAuthHeader from '../../../utils/withAuthHeader';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/actions/ui';

const Ball = styled(Box)`
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${props => props.color || '#119C4A'}   
`
const ContainerInfos = styled(Box)`
    display: flex;
    gap: 6px;
    align-items: center;
    width: 140px;
    flex-wrap: nowrap;
`
const Button = styled(ButtonMUI)`
    border: 1px solid white !important;
    color: ${props => props.theme.colors.white} !important;
`

export const ButtonSave = styled(ButtonMUI)`
    background-color:${props => props.theme.colors.primary} !important;
    border-radius: 8px !important;
    padding: 6px 16px !important;
    color: white !important;
    &.Mui-disabled {
        opacity: 0.5 !important;
    }
`

const Text = styled(Typography)`
    color: ${props => props.theme.colors.white}
    font-size: 14px !important;
    flex-wrap: nowrap;
`
export const Footer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 32px;
`
export const ModalWrapper = styled(Box)`
    padding: 16px 30px;
`
export const ModalTitle = styled(Typography)`
    font-size: 18px !important;
    font-weight: 500 !important;
    color: ${props => props.theme.colors.primary}
`

export const ModalBody = styled(Box)`
    margin: 8px 0;
`

const ItemToCheck = styled(Box)`
    width: 100%;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    margin-bottom: ${props => props.mb || '0'}
`

const ItemToCheckTitle = styled(Box)`
    & svg {
        color: ${props => props.theme.colors.primary}
    }
`

export const StoreStatus = ({ storeId, deliveryStatusProp, counterStatusProp, isMultistore }) => {

    const dispatch = useDispatch();

    const [editModalOpened, setEditModalOpened] = useState(false);

    const [deliveryStatus, setDeliveryStatus] = useState(deliveryStatusProp);
    const [counterStatus, setCounterStatus] = useState(counterStatusProp);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [initialState, setInitialState] = useState({ deliveryStatus: deliveryStatusProp, counterStatus: counterStatusProp });

    const openStore = (delivery) => {
        return api.post('api/v1/dashboard/estabelecimentos/abrir',
            {
                "EstabelecimentoId": storeId || undefined,
                "Delivery": delivery
            },
            {
                ...withAuthHeader(),
                params: storeId ? { "EstabelecimentoId": storeId } : {},
            })
    }

    const closeStore = (delivery) => {
        return api.post('api/v1/dashboard/estabelecimentos/fechar', {
            "EstabelecimentoId": storeId || undefined,
            "Delivery": delivery
        }, {
            ...withAuthHeader(),
            params: storeId ? { "EstabelecimentoId": storeId } : {},
        })
    }

    const onSave = () => {
        let promises = [];
        if (deliveryStatus !== initialState.deliveryStatus) {
            promises = [deliveryStatus ? openStore(true) : closeStore(true)]
        }
        if (counterStatus !== initialState.counterStatus) {
            promises = [...promises, counterStatus ? openStore(false) : closeStore(false)];
        }

        if (promises.length) {
            setLoading(true)
            Promise.allSettled(promises).then((result) => {
                setLoading(false)
                const error = !!result.find((res) => res.status === "rejected");
                if (!!error) {
                    dispatch(showNotification({
                        type: 'error',
                        text: 'Erro ao salvar configurações'
                    }))
                    setDeliveryStatus(initialState.deliveryStatus);
                    setCounterStatus(initialState.counterStatus);
                    return;
                }

                dispatch(showNotification({
                    type: 'success',
                    text: 'Configurações salvas com sucesso'
                }))
                setInitialState({ deliveryStatus, counterStatus })
            })
                .finally(() => {
                    setEditModalOpened(false);
                })
        }
    }

    const getInitialInfos = () => {
        setLoading(true);
        setError(false);
        return api.get('api/v1/dashboard/estabelecimentos/ObterStatus', {
            ...withAuthHeader(),
            params: storeId ? { "EstabelecimentoId": storeId } : {},
        }).then((resp) => {
            const deliveryStatus = !resp.data['FechadoTemporariamenteDelivery'];
            const counterStatus = !resp.data['FechadoTemporariamenteBalcao'];
            setDeliveryStatus(deliveryStatus);
            setCounterStatus(counterStatus);
            setInitialState({ deliveryStatus, counterStatus })
        })
            .finally(() => {
                setLoading(false)
            })
            .catch(() => {
                setError(true);
                dispatch(showNotification({
                    type: 'error',
                    text: 'Erro ao obter status do delivery e balcão.'
                }))
            })
    }

    useEffect(() => {
        if (isMultistore) return;
        getInitialInfos();
    }, [])

    useEffect(() => {
        if (isMultistore) {
            if (!storeId) {
                return;
            }
            getInitialInfos();
        }
    }, [storeId])

    return (
        <Box display="flex" gridGap="16px" alignItems="center">
            {
                error ? (
                    <>
                        <Button
                            variant='outlined'
                            color='default'
                            onClick={() => getInitialInfos(true)}
                            disabled={loading}
                        >
                            Tentar obter status novamente
                        </Button>
                    </>
                ) :
                    loading ? (<Loading />) :
                        (
                            <Box minWidth="140px">
                                <ContainerInfos>
                                    <Ball color={deliveryStatus ? '#119C4A' : '#FF001B'} />
                                    <Text> Delivery {deliveryStatus ? 'aberto' : 'fechado'}</Text>
                                </ContainerInfos>
                                <ContainerInfos>
                                    <Ball color={counterStatus ? '#119C4A' : '#FF001B'} />
                                    <Text> Balcão {counterStatus ? 'aberto' : 'fechado'}</Text>
                                </ContainerInfos>
                            </Box>
                        )
            }
            {
                (!error && !loading) && (
                    <Button
                        variant='outlined'
                        color='default'
                        onClick={() => setEditModalOpened(true)}
                        disabled={loading}
                    >
                        Fechar/Abrir loja
                    </Button>
                )
            }

            {
                editModalOpened && (
                    <Modal isOpen={editModalOpened} onClose={() => setEditModalOpened(false)} boxWidth={"450px"}>
                        <ModalWrapper>
                            <ModalTitle>Fechar/Abrir loja</ModalTitle>
                            {
                                loading ? (<Loading />) : (
                                    <>
                                        <ModalBody>
                                            <ItemToCheck mb="12px">
                                                <ItemToCheckTitle display="flex" alignItems="center" gridGap="6px">
                                                    <MopedIcon color="primary" />
                                                    <Typography>Delivery</Typography>
                                                </ItemToCheckTitle>
                                                <FormControl mt="8px">
                                                    <FormLabelControl
                                                        style={{ marginLeft: 8, flexDirection: 'row-reverse', gap: '8px' }}
                                                        control={<IOSSwitch sx={{ m: 1 }} />}
                                                        checked={deliveryStatus}
                                                        label={deliveryStatus ? 'Aberto' : 'Fechado'}
                                                        onChange={() => {
                                                            setDeliveryStatus(!deliveryStatus);
                                                        }}
                                                    />
                                                </FormControl>
                                            </ItemToCheck>
                                            <ItemToCheck mb="12px">
                                                <ItemToCheckTitle display="flex" alignItems="center" gridGap="6px">
                                                    <StoreIcon color="primary" />
                                                    <Typography> Balcão</Typography>
                                                </ItemToCheckTitle>
                                                <FormControl mt="8px">
                                                    <FormLabelControl
                                                        style={{ marginLeft: 8, flexDirection: 'row-reverse', gap: '8px' }}
                                                        control={<IOSSwitch sx={{ m: 1 }} />}
                                                        checked={counterStatus}
                                                        label={counterStatus ? 'Aberto' : 'Fechado'}
                                                        onChange={() => {
                                                            setCounterStatus(!counterStatus)
                                                        }}
                                                    />
                                                </FormControl>
                                            </ItemToCheck>
                                        </ModalBody>
                                        <Footer>
                                            <ButtonSave
                                                variant='contained'
                                                onClick={() => onSave()}
                                                disabled={(initialState.deliveryStatus === deliveryStatus) && (initialState.counterStatus === counterStatus)}
                                            >
                                                Salvar
                                            </ButtonSave>
                                        </Footer>
                                    </>

                                )

                            }
                        </ModalWrapper>
                    </Modal>
                )
            }
        </Box>
    )
}
